<template>
        <b-modal :id="'modalHelp'" size="lg" ref="helpModal" modal-class="modalHelp">
            <template #modal-header="{ close }">
                <h3 class="w-100 text-center">{{help.title}}</h3>
                <button type="button" class="close" @click="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <span v-html="this.helpContent" class="help-modal-content wrapper-content text-break"></span>
            <template #modal-footer>
                <a :href="get_help_endpoint" type="button" class="btn btn-white"><i class="fas fa-info-circle"></i> {{__('help_and_information') }}</a>
                <button type="button" class="btn btn-white" @click="closeModal()">{{__('close')}}</button>
            </template>
        </b-modal>

</template>

<script>
import { Fragment } from "vue-fragment";
import ButtonOpenHelpModal from "./ButtonOpenHelpModal.vue";
import events from './../../services/Events.js';

export default {
    name: 'help-modal',
    props: {
        'helpName' : {
            type: String,
            default: ''
        },
        'generateButton' : {
            type: Boolean,
            default: true
        },
        'inExtraDiv' : {
            type: Boolean,
            default: true
        }

    },
    data: () => ({
        help: {},
        get_localized_help_endpoint: '/admin/help/get-help-by-localization',
        get_help_endpoint : '/admin/help'
    }),
    components : {
        Fragment,
        ButtonOpenHelpModal
    },
    methods: {
        getHelp(helpName) {
            this.axios.get(
                this.get_localized_help_endpoint,
                {
                    params : {
                        'helpName' : helpName
                }
            })
            .then( res => {
                this.help = res.data;
            }).catch( error => {
                console.log(error)
            })
        },
        openModal(helpName) {
            this.getHelp(helpName);
            this.$refs.helpModal.show();
            setTimeout(() => {
                $('.modal-dialog').draggable({
                    handle: ".modal-header"

                });
            }, 1000)

        },
        closeModal() {
            this.$refs.helpModal.hide();
        },
        clearHelp() {
            this.help = {};
        }
    },
    computed : {
        helpContent : function () {
            return this.help.html ?? "" },
    },

    mounted: function () {
        events.$on('showHelpModal', helpName => {
            this.openModal(helpName);
        });

        this.$root.$on('bv::modal::hide', () => {
            this.clearHelp()
        });
    }

}
</script>

<style>
#modalHelp___BV_modal_outer_ {
    z-index: 5000!important;
}


 .modal-header h3 {
     text-align: center!important;
 }

</style>
